app.factory("NotificationService", ["$http", "$log",
    function ($http, $log) {
        var NotificationService = {};

        NotificationService.sendList = function (params) {
            return $http.get("/notification/list/send", {
                params: {
                    page: params.page || 1,
                    limit: params.limit || 25,
                    query: params.query,
                    fromDate: params.fromDate,
                    toDate: params.toDate,
                }
            }).then(function (resp) {
                return resp.data;
            });
        };

        NotificationService.send = function (notification) {
            return $http.post("/notification/send", notification).then(function (resp) {
                return resp.data;
            });
        };

        NotificationService.unread = function () {
            return $http.get("/notification/unread").then(function (resp) {
                return resp.data;
            })
        };

        NotificationService.received = function (params) {
            return $http.get("/notification/received", {
                params: {
                    page: params.page || 1,
                    limit: params.limit || 25,
                    state: params.state,
                    fromDate: params.fromDate,
                    toDate: params.toDate
                }
            }).then(function (resp) {
                return resp.data
            })
        };

        NotificationService.mark = function (params) {
            return $http.post("/notification/mark/" + params.notification, {
                state: params.state
            }).then(function (resp) {
                return resp.data
            })
        };

        NotificationService.getById = function (params) {
            return $http.get("/notification/one/" + params.notificationId).then(function (resp) {
                return resp.data
            })
        };

        return NotificationService;
    }
]);